import _, { get as _get } from 'lodash-es';
import { forOwn as _forOwn } from 'lodash-es';
import React, { useEffect, useState, useRef } from 'react';
import '../../styles/collectionFilter.scss';
import CollectionFilter from './CollectionFilter';
import AppliedFilters from '../abs-filter-components/AppliedFilters-collection';
import ProductSort from '../utils/ProductSort';
import ProductList from './ProductList';
import EcommerceApi from '../../api/EcommerceApi';
import Spinner from '../dynamic-configurator/dc-spinner/collectionSpinner';
import PriceFilter from '../collection-filters/PriceFilter';
import mrfcApplicationFilter from '../collection-filters/mrfc_application';

import {
  getFilterAttributesFromAPI,
  getFilterAttributesFromAPITry,
  sortProductList,
  sortFilterValues,
  sortFilterValuesCollection,
  getCurrentFiltersForCollection,
} from '../utils/HelperMethods';
import { productsPerPage, shopifyObj } from '../utils/Constants';
import CompatioAnalytics from '../../api/CompatioAnalytics';

const trackAnchorClick = data => {
  CompatioAnalytics.track(CompatioAnalytics.events.collectionFilterApplied, {
    collection_name: data[2],
    filter_name: data[0],
    filter_value: data[1],
    applied_filters: data[3],
    click_action: CompatioAnalytics.clicks.collectionFilterSort,
  });
};

export default function CollectionFilterSection() {
  const [appliedFilters, SetAppliedFilters] = useState(
    getCurrentFiltersForCollection()
  );

  const [ShowOptions, SetShowOptions] = useState(false);
  const [collectionProductPop, setCollectionProductPop] = useState(false);
  const [productData, SetProductData] = useState([]);
  const [sortOrder, SetSortOrder] = useState('best_selling');
  const [isFilterCollapsed, SetIsFilterCollapsed] = useState(true);
  const [activeFilterIndex, SetActiveFilterIndex] = useState(-1);
  const [filteredData, SetFilteredData] = useState([]);
  const [responseData, SetResponseData] = useState([]);
  const [filterData, SetFilterData] = useState([]);
  const [masterFilterOptions, SetMasterFilterOptions] = useState([]);
  const [isLoading, SetIsLoading] = useState(true);
  const [isError, SetIsError] = useState(false);
  const [LastFilterSelect, SetLastFilterSelect] = useState([]);

  const [uniqueproductType, SetIsuniqueproductType] = useState([]);
  const [uniqueproductVendor, SetIsuniqueproductVendor] = useState([]);
  const [uniquePriceFilter, Setpricefilter] = useState([]);
  const [filterTypeProducts, SetIsfilterTypeProducts] = useState([]);
  const [applyFilterCheck, SetapplyFilterCheck] = useState(false);
  const [checkLocalStorage, SetcheckLocalStorage] = useState(false);
  const [blurEffect, SetblurEffect] = useState(true);

  const [mainProductObject, SetmainProductObject] = useState([]);
  const ref = useRef();

  let afterFilterNextSet = [];

  const DataLiveCheck = _get(window, 'compatioConfig.DataJson')
    ? _get(window, 'window.compatioConfig.DataJson')
    : [];
  const DefalutBaseUrl = _get(window, 'compatioConfig.shopify.baseUrlDefault')
  ? _get(window, 'window.compatioConfig.shopify.baseUrlDefault')
  : [];

  const DataLocalSet = [...DataLiveCheck];

  // console.log(DataLocalSet, 'localData');
  const checkIfClickedOutside = e => {
    // If the menu is open and the clicked target is not within the menu,
    // then close the menu
    if (!isFilterCollapsed && ref.current && !ref.current.contains(e.target)) {
      SetIsFilterCollapsed(true);
      SetActiveFilterIndex(-1);
    }
  };

  const getCollectionFilterData = async sortKey => {
    DataLocalSet.forEach(e => {
      e.productID = `${e.productID}`;
      e.url_image = e.featured_image;
      if (e.images[1] != undefined) {
        e.url_image_two = e.images[1];
      }
      e.productName = e.title;
      e.productVendor = e.vendor;
      // e.product_url = window.location.href + '/products/' + e.handle;
      e.product_url = DefalutBaseUrl + '/products/' + e.handle;
      e.createdAt = e.created_at;
      e.variants.forEach(eVariant => {
        eVariant.variantID = `${eVariant.variantID}`;
      });
    });
    // console.log(localData)
    // this created by gaurav start
    let productTypefil = [],
      productVendorfil = [];
    // this created by gaurav end
    try {
      // const ProductDataFromCommerce = await EcommerceApi.loadCollectionDataFromECommerce(
      //   shopifyObj.collectionHandle,
      //   sortKey
      // );
      // console.log(ProductDataFromCommerce,'ProductDataFromCommercddddddde')
      const sortedData =
        sortOrder === 'default'
          ? DataLocalSet
          : sortProductList(sortOrder, DataLocalSet);
      // console.log(localData,ProductDataFromCommerce)
      const getLocal = [];
      DataLocalSet.filter(e => {
        getLocal.push(`${e.productID}`);
      });
      // console.log(getLocal,'getLocal')
      const filterAttributes = await getFilterAttributesFromAPITry(
        // ProductDataFromCommerce
        getLocal
      );
      const varientList = [];
      // below this logic work when our api give zero response means if there is no data
      if (filterAttributes.length == 0) {
        const DuplicateData = _.cloneDeep(DataLocalSet);
        DuplicateData.forEach(e => {
          e.variants.map(ev => {
            ev.variant_id = ev.variantID;
            ev.product_id = e.productID;
            ev.abs_string = null;
            filterAttributes.push(ev);
          });
        });
      }

      DataLocalSet.forEach(x => {
        x.variants.forEach(xe => {
          if (xe.variantID !== undefined) {
            varientList.push(xe.variantID);
          }
        });
        // console.log(varientList,'varientList')
        var venDorse = {
          attr: 'productVendor',
          meta: {
            displaySearch: false,
            valuesPerRow: 1,
            maxHeight: 'Medium',
            DisplayType: 'displayValue',
            displayName: 'productVendor',
          },
          vals: {
            meta: {
              display_value: x.productVendor,
              alt_text: '',
              image_url: '',
            },
            value: x.productVendor,
          },
          rank: '0',
        };

        // uniqueproductVendor.push(x.productVendor);
        uniqueproductVendor.push(venDorse);

        var prodTypese = {
          attr: 'productType',
          meta: {
            displaySearch: false,
            valuesPerRow: 1,
            maxHeight: 'Medium',
            DisplayType: 'displayValue',
            displayName: 'productType',
          },
          vals: {
            meta: { display_value: x.type, alt_text: '', image_url: '' },
            value: x.type,
          },
          rank: '0',
        };

        uniqueproductType.push(prodTypese);

        var prodPriceFilter = {
          attr: 'priceFilter',
          meta: {
            displaySearch: false,
            valuesPerRow: 1,
            maxHeight: 'Medium',
            DisplayType: 'displayValue',
            displayName: 'priceFilter',
          },
          vals: {
            meta: { display_value: x.price, alt_text: '', image_url: '' },
            value: x.price,
          },
          rank: '0',
        };
        uniquePriceFilter.push(prodPriceFilter);
      });

      const preSetDatafilter = filterAttributes.map(e => e);
      const setDataForfilter = varientList.map(e => {
        if (e !== undefined) {
          return e;
        }
      });

      const updatedfilterAttributes = preSetDatafilter.filter(x =>
        setDataForfilter.includes(x.variant_id)
      );

      processtTheFilterData(updatedfilterAttributes, sortedData);
      // SetIsLoading(false);
    } catch (error) {
      SetIsLoading(false);
      SetIsError(true);
    }
  };

  const handleChangeSortOrder = sortOrder => {
    SetSortOrder(sortOrder);
  };

  const handleFilterCollapse = (index, filtertypename) => {
    let currentFilterState = !isFilterCollapsed;
    if (!isFilterCollapsed) {
      SetActiveFilterIndex(-1);
    } else SetActiveFilterIndex(index);
    SetIsFilterCollapsed(currentFilterState);
    SetLastFilterSelect(filtertypename);
    // alert(filtertypename)
  };

  const processtTheFilterData = (APIResponse, ProductData) => {
    // console.log(APIResponse,ProductData,'ProductData')
    let filterNames = [];

    filterNames.push({
      attr: 'productVendor',
      name: 'Manufacture',
      values: [
        ...uniqueproductVendor
          .map(e => e.vals)
          .filter(
            ({ value }, index) =>
              !uniqueproductVendor
                .map(e => e.vals)
                .map(o => o.value)
                .includes(value, index + 1)
          ),
      ],
      valuesPerRow: '1',
      rank: -1,
    });

    filterNames.push({
      attr: 'productType',
      name: 'Product Type',
      values: [
        ...uniqueproductType
          .map(e => e.vals)
          .filter(
            ({ value }, index) =>
              !uniqueproductType
                .map(e => e.vals)
                .map(o => o.value)
                .includes(value, index + 1)
          ),
      ],
      valuesPerRow: '1',
      rank: 0,
    });
    filterNames.push({
      attr: 'priceFilter',
      name: 'Price Filter',
      values: [
        ...uniquePriceFilter
          .map(e => e.vals)
          .filter(
            ({ value }, index) =>
              !uniquePriceFilter
                .map(e => e.vals)
                .map(o => o.value)
                .includes(value, index + 1)
          ),
      ],
      valuesPerRow: '1',
      rank: 0,
    });

    let newProductData =
      APIResponse && APIResponse.length === 0 ? ProductData : [];

    SetIsfilterTypeProducts([
      [...new Set(uniqueproductType)],
      [...new Set(uniqueproductVendor)],
      [...new Set(uniquePriceFilter)],
    ]);

    if (APIResponse && APIResponse.length > 0) {
      APIResponse.forEach(element => {
        if (element.abs_string != null) {
          let filters = JSON.parse(element.abs_string);
          filters.forEach(eachfilter => {
            if ('rod-pieces' == eachfilter.attr) {
            }
            eachfilter.meta = JSON.parse(eachfilter.meta);
          });
          element.abs_string = filters;
        }
      });
      // console.log(APIResponse, 'APIResponse');

      ProductData.forEach(product => {
        product.variants.forEach(element => {
          let filterAttributes = APIResponse.find(
            each => each.variant_id === element.variantID
          );
          // console.log(product)

          if (filterAttributes && filterAttributes.abs_string) {
            let checkCustomWaterType = mrfcApplicationFilter.find(
              eWatertype =>
                eWatertype.Variant_id === +filterAttributes.variant_id
            );
            if (checkCustomWaterType) {
              filterAttributes.abs_string.map(absMap => {
                if (absMap.attr == 'water-type') {
                  absMap.vals.push({
                    meta: {
                      display_value: '',
                      alt_text: '',
                      image_url: '',
                    },
                    value: checkCustomWaterType.Application,
                  });
                }
              });
            }

            element.filter_attrs = [
              ...filterAttributes.abs_string,
              {
                attr: 'productVendor',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Manufacture',
                },
                vals: [
                  {
                    meta: {
                      display_value: product.productVendor,
                      alt_text: '',
                      image_url: '',
                    },
                    value: product.productVendor,
                  },
                ],
                rank: -1,
              },
              {
                attr: 'productType',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Product Type',
                },
                vals: [
                  {
                    meta: {
                      display_value: product.type,
                      alt_text: '',
                      image_url: '',
                    },
                    value: product.type,
                  },
                ],
                rank: 0,
              },
              {
                attr: 'priceFilter',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Price Filter',
                },
                vals: [
                  {
                    meta: {
                      display_value: element.price,
                      alt_text: '',
                      image_url: '',
                    },
                    value: element.price,
                  },
                ],
                rank: 0,
              },
            ];
          } else {
            element.filter_attrs = [
              {
                attr: 'productVendor',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Manufacture',
                },
                vals: [
                  {
                    meta: {
                      display_value: product.productVendor,
                      alt_text: '',
                      image_url: '',
                    },
                    value: product.productVendor,
                  },
                ],
                rank: -1,
              },
              {
                attr: 'productType',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Product Type',
                },
                vals: [
                  {
                    meta: {
                      display_value: product.type,
                      alt_text: '',
                      image_url: '',
                    },
                    value: product.type,
                  },
                ],
                rank: 0,
              },
              {
                attr: 'priceFilter',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Price Filter',
                },
                vals: [
                  {
                    meta: {
                      display_value: element.price,
                      alt_text: '',
                      image_url: '',
                    },
                    value: element.price,
                  },
                ],
                rank: 0,
              },
            ];
          }
        });
        newProductData.push(product);
      });
      // console.log(newProductData,'newProductData')
      const tempArray = _.cloneDeep(APIResponse);

      tempArray.forEach(eachProduct => {
        let group = _.groupBy(eachProduct.abs_string, 'attr');
        _forOwn(group, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNames.findIndex(each => each.attr === key);
            if (index === -1) {
              filterNames.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: '1',
                rank: each.rank,
              });
            } else {
              let newValues = filterNames[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNames[index].values = newValues;
            }
          });
        });
      });

      // console.log(filterNames,'tempArray')
      // console.log('1',filterNames)
      const sortedFilters = sortFilterValuesCollection(filterNames);

      sortedFilters.sort(function(a, b) {
        return parseFloat(a.rank) - parseFloat(b.rank);
      });
      // console.log(sortedFilters, 'sortedFilters');
      SetmainProductObject(newProductData);
      if (appliedFilters.length > 0) {
        // console.log(
        //   // appliedFilters,
        //   'appliedFilters',
        //   // newProductData,
        //   sortedFilters
        // );
        updateProductList(newProductData, newProductData, sortedFilters);
        SetblurEffect(false);
        SetProductData(newProductData);
      } else {
        SetProductData(newProductData);
        SetFilterData([...sortedFilters]);
        // console.log(newProductData)
        SetFilteredData(newProductData);
        SetblurEffect(false);
      }
      SetResponseData(APIResponse);
      SetMasterFilterOptions(sortedFilters);
    } else {
      let Newprolist = [];
      let filterType = [];

      const sortedFilters = sortFilterValuesCollection(filterNames);
      ProductData.forEach(eachProduct => {
        let group = _.groupBy(eachProduct.abs_string, 'attr');
        // console.log(eachProduct,'fa')
        _forOwn(group, (filterType, key) => {
          filterType.forEach(each => {
            let index = filterNames.findIndex(each => each.attr === key);
            if (index === -1) {
              filterNames.push({
                attr: key,
                name: each.meta.displayName,
                values: each.vals,
                valuesPerRow: '1',
                rank: each.rank,
              });
            } else {
              let newValues = filterNames[index].values;
              each.vals.forEach(val => {
                if (
                  newValues.findIndex(each => each.value === val.value) === -1
                )
                  newValues.push(val);
              });
              filterNames[index].values = newValues;
            }
          });
        });
      });

      ProductData.forEach(product => {
        product.variants.forEach(element => {
          let filterAttributes = APIResponse.find(
            each => each.variant_id === element.variantID
          );
          if (filterAttributes) {
            element.filter_attrs = [
              {
                attr: 'productVendor',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Manufacture',
                },
                vals: [
                  {
                    meta: {
                      display_value: product.productVendor,
                      alt_text: '',
                      image_url: '',
                    },
                    value: product.productVendor,
                  },
                ],
                rank: -1,
              },
              {
                attr: 'productType',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Product Type',
                },
                vals: [
                  {
                    meta: {
                      display_value: product.type,
                      alt_text: '',
                      image_url: '',
                    },
                    value: product.type,
                  },
                ],
                rank: 0,
              },
              {
                attr: 'priceFilter',
                meta: {
                  displaySearch: false,
                  valuesPerRow: 1,
                  maxHeight: 'Medium',
                  DisplayType: 'displayValue',
                  displayName: 'Price Filter',
                },
                vals: [
                  {
                    meta: {
                      display_value: element.price,
                      alt_text: '',
                      image_url: '',
                    },
                    value: element.price,
                  },
                ],
                rank: 0,
              },
            ];
          }
        });
        Newprolist.push(product);
      });

      SetProductData(newProductData);
      SetFilteredData(newProductData);
      SetFilterData([...sortedFilters]);
    }

    SetIsLoading(false);
    var div = document.getElementById('data-compatio-collection-products');
    div.style.display = 'none';
  };
  //////////////////////////----- Ok Function

  //updates the list of product based on applied filters
  const updateProductList_bkp = (
    currentProductData,
    currentFilteredData,
    filterOptionsData
  ) => {
    // ...

    let applicableAttributesFilter = [];
    let filterGroups = _.groupBy(appliedFilters, 'name');
    const filterSets = [];

    _forOwn(filterGroups, (filterObj, key) => {
      let values = filterObj.map(each => each.value);
      filterSets.push({ attribute: key, values });
    });

    const rootProducts = _.cloneDeep(currentProductData);

    let dataList = [];

    if (rootProducts !== undefined) {
      dataList = rootProducts.filter(product => {
        let productMatch = false;

        for (const variant of product.variants) {
          const matchedFilter = [];

          // ...

          if (variant.filter_attrs !== undefined) {
            filterSets.forEach(filterItem => {
              const isPriceFilter = filterItem.attribute === 'priceFilter';

              const matchedVariants = variant.filter_attrs.filter(attr => {
                // ...

                return isPriceFilter
                  ? attr.attr === 'priceFilter' &&
                      filterItem.values[0] >= attr.vals[0].value
                  : attr.attr === filterItem.attribute ||
                      attr.vals[0].value == filterItem.values[0];
              });

              const matchedVariant = matchedVariants.find(attr => true);

              if (matchedVariants.length > 0 && matchedVariant !== undefined) {
                if (isPriceFilter || matchedVariants[0].vals.length <= 1) {
                  matchedFilter.push(
                    filterItem.values.includes(matchedVariant.vals[0].value)
                  );
                } else {
                  const includesValues = matchedVariants[0].vals.some(v =>
                    filterItem.values.includes(v.value)
                  );
                  matchedFilter.push(includesValues);
                }
              }
            });

            if (
              matchedFilter.every(x => x) &&
              matchedFilter.length === filterSets.length
            ) {
              productMatch = true;
            }
          }
          // ...
        }

        return productMatch;
      });
    }

    // ...

    let applicableAttributesFilterForVendor = [];
    let filterMerger = [];

    // ...

    if (appliedFilters.length === 0) {
      if (sortOrder !== undefined && sortOrder !== 'default') {
        SetFilteredData(sortProductList(sortOrder, currentProductData));
      } else {
        SetFilteredData(currentProductData);
        localStorage.removeItem(shopifyObj.collectionHandle);
      }
      SetFilterData(masterFilterOptions);
    } else {
      // ...

      if (dataList.length !== 0) {
        if (afterFilterNextSet.length === 0) {
          SetFilterData([...JSON.parse(localStorage.getItem('FilterDataSet'))]);
        } else {
          SetFilterData([...filterMerger.filter(e => e !== undefined)]);
        }
        if (applyFilterCheck) {
          localStorage.setItem(
            'FilterDataSet',
            JSON.stringify(afterFilterNextSet)
          );
          SetapplyFilterCheck(false);
        }
      }

      if (dataList.length !== 0) {
        if (sortOrder !== undefined && sortOrder !== 'default') {
          SetFilteredData(sortProductList(sortOrder, dataList));
        } else {
          SetFilteredData(dataList);
        }

        if (dataList.length !== 0) {
          FilterUpdateData(
            [...filterMerger.filter(e => e !== undefined)],
            LastFilterSelect,
            dataList
          );
        }
      }
    }
  };

  const updateProductList = (
    currentProductData,
    currentFilteredData,
    filterOptionsData
  ) => {
    let applicableAttributesFilter = [];
    let filterGroups = _.groupBy(appliedFilters, 'name');
    const filterSets = [];
    // console.log(filterGroups,'filterGroups')
    _forOwn(filterGroups, (filterObj, key) => {
      let values = [];
      filterObj.forEach(each => values.push(each.value));
      filterSets.push({ attr: key, values: values });
    });
    const rootProductss = _.cloneDeep(currentProductData);

    let dataList = [];
    //below is old filter functionality
    // this is copy from builder filter functionality
    if (rootProductss != undefined) {
      dataList = rootProductss.filter(x => {
        let productMatch = false;
        //variants looping
        let checkvariant = [];
        for (const y of x.variants) {
          // console.log(x.variants,'fd')
          // x.variants.forEach(y=> {
          const matchedFilter = [];
          const matchedFilterfortow = [];
          // filter attributes looping
          //custom filter
          if (y.filter_attrs != undefined) {
            filterSets.forEach(filterItem => {
              if (filterItem.attr == 'priceFilter') {
                const matchedVariantd = y.filter_attrs.filter(z => {
                  if (
                    z.attr === 'priceFilter' &&
                    filterItem.values[0] >= z.vals[0].value
                  ) {
                    return z;
                  }
                });
                const matchedVariant = y.filter_attrs.find(z => {
                  if (
                    z.attr === 'priceFilter' &&
                    filterItem.values[0] >= z.vals[0].value
                  ) {
                    return z;
                  }
                });
                if (matchedVariantd.length != 0) {
                  if (matchedVariant != undefined) {
                    matchedFilter.push(filterItem.values);
                  }
                }
              } else {
                const matchedVariantd = y.filter_attrs.filter(
                  z =>
                    z.attr === filterItem.attr ||
                    z.vals[0].value == filterItem.values[0]
                );
                const matchedVariant = y.filter_attrs.find(
                  z =>
                    z.attr === filterItem.attr ||
                    z.vals[0].value == filterItem.values[0]
                );
                // console.log(matchedVariant,matchedVariantd,y.filter_attrs,'filterSets')
                y.filter_attrs.forEach(z => {
                  if (z.attr == filterItem.attr) {
                    let gs = z.vals.filter(t => {
                      if (filterItem.values.length > 1) {
                        let ty = filterItem.values.filter(y => {
                          if (y == t.value) {
                            return y;
                          }
                        });
                        if (ty.length != 0) {
                          return t;
                        }
                      } else {
                        if (filterItem.values[0] == t.value) {
                          return t;
                        }
                      }
                    });
                    if (gs.length != 0) {
                      matchedFilter.push(true);
                    }
                  }

                  // return z
                });

                if (matchedVariantd.length != 0) {
                  if (matchedVariant != undefined) {
                    if (matchedVariantd[0].vals.length > 1) {
                      var i = 0;
                      matchedVariantd[0].vals.filter(et => {
                        if (
                          filterItem.values.includes(
                            matchedVariantd[0].vals[i].value
                          ) == true
                        ) {
                          // matchedFilter.push(
                          //   filterItem.values.includes(
                          //     matchedVariantd[0].vals[i].value
                          //   )
                          // );
                        }
                        i++;
                      });
                    } else {
                      if (
                        filterItem.values.includes(
                          matchedVariantd[0].vals[0].value
                        ) == true
                      ) {
                        // matchedFilter.push(
                        //   filterItem.values.includes(matchedVariantd[0].vals[0].value)
                        // );
                      }
                    }
                  }
                } else if (matchedVariant != undefined) {
                  // console.log(filterItem.values, matchedVariant.vals[0].value ,y,'matchedVariant')
                  matchedFilter.push(
                    filterItem.values.includes(matchedVariant.vals[0].value)
                  );
                }
              }
            });
            // test.push('matchedFilters', matchedFilter.length, filterSets.length)
            // console.log(matchedFilter,'matchedFilter')
            x.variants = [];
            if (
              matchedFilter.every(x => x) &&
              matchedFilter.length == filterSets.length
            ) {
              checkvariant.push(y);
              productMatch = true;
            }
            x.variants = checkvariant;
          }
        }
        // console.log(productMatch,'productMatch')
        return productMatch;
      });
    }

    let PrevFiltersest = masterFilterOptions.map(e => e.attr);

    let DataForUpdateFilterAfterthat = _.cloneDeep([...dataList]);

    // console.log(DataForUpdateFilterAfterthat,dataList,'DataForUpdateFilterAfterthat')

    DataForUpdateFilterAfterthat.forEach(eachProduct => {
      eachProduct.variants.forEach(variant => {
        let group = _.groupBy(variant.filter_attrs, 'attr');

        _forOwn(group, (filterType, key) => {
          filterType.forEach(each => {
            let index = applicableAttributesFilter.findIndex(
              item => item.attr === key
            );

            if (index === -1) {
              applicableAttributesFilter.push({
                attr: key,
                name: each.meta.displayName,
                values: [...each.vals], // Using spread operator for shallow copy
                valuesPerRow: '1',
                rank: each.rank,
              });
            } else {
              let existingValues = new Set(
                applicableAttributesFilter[index].values.map(val => val.value)
              );

              each.vals.forEach(val => {
                if (!existingValues.has(val.value)) {
                  applicableAttributesFilter[index].values.push(val);
                  existingValues.add(val.value);
                }
              });
            }
          });
        });
      });
    });

    let applicableAttributesFilterforVendor = [];

    PrevFiltersest.forEach(b => {
      if (LastFilterSelect != b) {
        applicableAttributesFilter.forEach(e => {
          if (e.attr != LastFilterSelect) {
            if (e.attr == b) {
              afterFilterNextSet.push(e);
            }
          }
        });
      } else {
        filterData.forEach(e => {
          if (e.attr == LastFilterSelect) {
            afterFilterNextSet.push(e);
          }
        });
      }
    });

    let vendorfilterset = [];
    PrevFiltersest.forEach(b => {
      if (LastFilterSelect != b) {
        applicableAttributesFilterforVendor.forEach(e => {
          if (e.attr != LastFilterSelect) {
            if (e.attr == 'productVendor') {
              vendorfilterset.push(e);
            }
          }
        });
      }
    });
    let filtermerger = [
      vendorfilterset[0],
      ...afterFilterNextSet.filter(
        e => e.attr != 'productVendor' || vendorfilterset[0] == undefined
      ),
    ];

    // console.log(afterFilterNextSet,'afterFilterNextSet',masterFilterOptions.find(e=>e.attr == LastFilterSelect),LastFilterSelect)
    if (appliedFilters.length === 0) {
      // console.log(sortProductList(sortOrder, currentProductData),'sortProductList(sortOrder, currentProductData)')
      if (sortOrder != undefined && sortOrder !== 'default') {
        SetFilteredData(sortProductList(sortOrder, currentProductData));
      } else {
        SetFilteredData(currentProductData);
        // SetFilteredData(sortProductList(sortOrder, currentProductData));
        localStorage.removeItem(shopifyObj.collectionHandle);
      }
      SetFilterData(masterFilterOptions);
    } else {
      //SetFilterData update filters data according to current productc data
      // console.log(appliedFilters,'appliedFilters',afterFilterNextSet)
      //  console.log(masterFilterOptions,'masterFilterOptions')
      // console.log(newData, 'newData.length');
      if (dataList.length != 0) {
        if (afterFilterNextSet.length == 0) {
          SetFilterData([...JSON.parse(localStorage.getItem('FilterDataSet'))]);
          // console.log(
          //   JSON.parse(localStorage.getItem('FilterDataSet')),
          //   'parse',
          //   afterFilterNextSet
          // );
        } else {
          // SetFilterData([...afterFilterNextSet]);
          SetFilterData([...filtermerger.filter(e => e != undefined)]);
        }
        if (applyFilterCheck == true) {
          localStorage.setItem(
            'FilterDataSet',
            JSON.stringify(afterFilterNextSet)
          );
          SetapplyFilterCheck(false);
        }
      }
      // console.log(afterFilterNextSet, 'afterFilterNextSet');
      // console.log(currentProductData,'currentProductData 2',appliedFilters,dataList)
      if (sortOrder != undefined && sortOrder != 'default') {
        SetFilteredData(sortProductList(sortOrder, dataList));
      } else {
        // dataList = sortProductList(sortOrder, dataList);
        SetFilteredData(dataList);
      }
      // console.log(dataList,'datalist',[...filtermerger.filter(e => e != undefined)],
      // LastFilterSelect,
      // dataList);
      if (dataList.length != 0) {
        // console.log(
        //   [...filtermerger.filter(e => e != undefined)],
        //   LastFilterSelect,
        //   dataList
        // );
        FilterUpdateData(
          [...filtermerger.filter(e => e != undefined)],
          LastFilterSelect,
          dataList
        );
        // console.log(dataList, 'dataList');
      }
    }
  };

  const [removelastfilter, Setremovelastfilter] = useState(false);

  //gaurav
  const FilterUpdateData = (
    filterData,
    LastFilterSelect,
    filterDataProductCloen
  ) => {
    const updatedFilterAttData = [];

    filterData.forEach(es => {
      const rootproductmainclone = _.cloneDeep(mainProductObject);
      const lastFilterProductsdata = [];
      let ie =
        LastFilterSelect != undefined
          ? LastFilterSelect
          : removelastfilter.name;
      if (es.attr != ie) {
        let filterGroups = _.groupBy(
          appliedFilters.filter(e => e.name != es.attr),
          'name'
        );
        const filterSets = [];
        _forOwn(filterGroups, (filterObj, key) => {
          let values = [];
          filterObj.forEach(each => values.push(each.value));
          filterSets.push({ attr: key, values: values });
        });
        // console.log(rootproductmainclone,'rootproductmainclone',filterSets)
        rootproductmainclone.forEach(x => {
          let productMatch = false;
          //variants looping
          let checkvariant = [];
          // console.log(x, 'x');
          for (const y of x.variants) {
            // x.variants.forEach(y=> {
            const matchedFilter = [];
            // filter attributes looping

            if (y.filter_attrs != undefined) {
              filterSets.forEach(filterItem => {
                if (filterItem.attr == 'priceFilter') {
                  y.filter_attrs.forEach(z => {
                    if (z.attr == filterItem.attr) {
                      let gs = z.vals.filter(t => {
                        let ty = filterItem.values.filter(y => {
                          // console.log(filterItem,z,+y,t.value)
                          if (z.attr === 'priceFilter' && +y >= t.value) {
                            // console.log(z.attr , filterItem.attr,'part tow', z.vals , filterItem,y,t.value)
                            return y;
                          }
                        });
                        if (ty.length != 0) {
                          return t;
                        }
                      });
                      if (gs.length != 0) {
                        matchedFilter.push(true);
                      }
                    }
                    // console.log(z,'z')
                    // console.log(z,filterItem,'testFilter', z.attr == filterItem.attr )
                    // return z
                  });
                } else {
                  // console.log(filterItem,'filterItem.attr')
                  y.filter_attrs.forEach(z => {
                    if (z.attr == filterItem.attr) {
                      let gs = z.vals.filter(t => {
                        if (filterItem.values.length > 1) {
                          let ty = filterItem.values.filter(y => {
                            if (y == t.value) {
                              // console.log(z.attr , filterItem.attr,'part tow', z.vals , filterItem,y,t.value)
                              return y;
                            }
                          });
                          if (ty.length != 0) {
                            return t;
                          }
                        } else {
                          if (filterItem.values[0] == t.value) {
                            return t;
                          }
                          // console.log(t,'testFilter')
                          // console.log(z.attr , filterItem.attr,'[part one]', z.vals , filterItem.values[0] ,t.value)
                        }
                      });
                      if (gs.length != 0) {
                        // console.log(z,'z',z.attr==filterItem.attr)
                        matchedFilter.push(true);
                      }
                    }
                    // console.log(z,'z')
                    // console.log(z,filterItem,'testFilter', z.attr == filterItem.attr )
                    // return z
                  });
                }
              });
              x.variants = [];
              if (
                matchedFilter.every(x => x) == true &&
                matchedFilter.length == filterSets.length
              ) {
                // if (matchedFilter.every(x => x) == true) {
                checkvariant.push(y);
                productMatch = true;
              }
              x.variants = checkvariant;
              lastFilterProductsdata.push(x);
            }
          }
          // return productMatch;
        });
        let applicableAttributesFilterforVendor = [];
        lastFilterProductsdata.forEach(eachProduct => {
          if (eachProduct.variants.length != 0) {
            // console.log(eachProduct,'lastFilterProductsdata')
            eachProduct.variants.forEach(variant => {
              let groupe = _.groupBy(variant.filter_attrs, 'attr');
              // console.log(group,'eachProducteachProduct')
              _forOwn(groupe, (filterType, key) => {
                filterType.forEach(each => {
                  if (each.attr == es.attr) {
                    let index = applicableAttributesFilterforVendor.findIndex(
                      each => each.attr === key
                    );
                    if (index === -1) {
                      applicableAttributesFilterforVendor.push({
                        attr: key,
                        name: each.meta.displayName,
                        values: each.vals,
                        valuesPerRow: '1',
                        rank: each.rank,
                      });
                    } else {
                      let newValues =
                        applicableAttributesFilterforVendor[index].values;
                      each.vals.forEach(val => {
                        if (
                          newValues.findIndex(
                            each => each.value === val.value
                          ) === -1
                        ) {
                          newValues.push(val);
                        }
                      });
                      applicableAttributesFilterforVendor[
                        index
                      ].values = newValues;
                    }
                  }
                });
              });
            });
          }
        });

        // console.log(
        //   applicableAttributesFilterforVendor[0],
        //   es.attr , ie,'fd',filterData
        // );
        if (applicableAttributesFilterforVendor[0] == undefined) {
          updatedFilterAttData.push(
            filterData.filter(u => u.attr == es.attr)[0]
          );
        } else {
          updatedFilterAttData.push(applicableAttributesFilterforVendor[0]);
        }
      } else {
        updatedFilterAttData.push(es);
      }
    });

    // console.log(updatedFilterAttData.filter(e=>e != undefined),'updatedFilterAttData',LastFilterSelect)
    if (updatedFilterAttData.filter(ed => ed != undefined).length != 0) {
      SetFilterData(
        sortFilterValues(
          updatedFilterAttData
            .filter(ed => ed != undefined)
            .sort(function(a, b) {
              return parseFloat(a.rank) - parseFloat(b.rank);
            })
        )
      );
    }
  };

  //update filters applied
  const updateValueToFilters = (
    displayName,
    type,
    metaValue,
    value,
    attribute,
    isFilterAdd
  ) => {
    const filtercustomData = [displayName, value, shopifyObj.collectionHandle];
    SetLastFilterSelect(type);
    let newFilters = appliedFilters === null ? [] : [...appliedFilters];
    let ifFilterPresent = newFilters.find(
      filter => filter.name === type && filter.value === value
    );

    // newFilters.find(
    //   filter => {
    //     console.log(filter.name , type ,'//', filter.value >= value)
    //   }
    // );
    if (ifFilterPresent != undefined) {
      if (!isFilterAdd) {
        newFilters = newFilters.filter(each => {
          //each.name != ifFilterPresent.name &&
          // console.log(each, ifFilterPresent,'each.name != ifFilterPresent.name')
          return (
            each.value != ifFilterPresent.value ||
            each.name != ifFilterPresent.name
          );
        });
      }
      SetAppliedFilters(newFilters);
      trackAnchorClick([...filtercustomData, newFilters]);
      // console.log(newFilters,'newFilters');
    } else {
      if (type == 'priceFilter') {
        const newsetFiler = newFilters.filter(e => e.name != 'priceFilter');
        newsetFiler.push({
          name: type,
          displayName: displayName,
          value: value,
          metaValue: metaValue,
          attribute: attribute,
        });
        SetAppliedFilters(newsetFiler);
        trackAnchorClick([...filtercustomData, newFilters]);
      } else {
        newFilters.push({
          name: type,
          displayName: displayName,
          value: value,
          metaValue: metaValue,
          attribute: attribute,
        });
        SetAppliedFilters(newFilters);
        trackAnchorClick([...filtercustomData, newFilters]);
      }

      // console.log(newFilters,'newFilters 2');
    }
    // console.log(newFilters,'newFilters') comment by gaurav
    if (newFilters.length === 0) {
      localStorage.removeItem(shopifyObj.collectionHandle);
    } else {
      localStorage.setItem(
        shopifyObj.collectionHandle,
        JSON.stringify(newFilters)
      );
    }
  };

  const handleClick = () => {
    var getFilterSection = document.getElementById('filterSection');
    if (getFilterSection.style.display === 'none') {
      getFilterSection.style.display = 'block';
    } else if (getFilterSection.style.display == '') {
      getFilterSection.style.display = 'block';
    } else {
      getFilterSection.style.display = 'none';
    }
  };

  //effects and handles
  useEffect(() => {
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isFilterCollapsed]);

  useEffect(() => {
    // getCollectionFilterData('MANUAL');
  }, []);

  useEffect(() => {
    if (appliedFilters.length >= localStorage.getItem('applidefilterlenth')) {
      updateProductList(productData, filteredData, mainProductObject);
    } else {
      updateProductList(productData, filteredData, mainProductObject);
      // updateProductListRemove(productData, filteredData, mainProductObject);
    }
    // console.log(filteredData,productData,mainProductObject,'filteredData',appliedFilters)
    localStorage.setItem('applidefilterlenth', appliedFilters.length);
    // console.log(filteredData,'filteredData')
  }, [appliedFilters]);

  useEffect(() => {
    if (sortOrder && sortOrder !== 'default') {
      const newSortedData = sortProductList(sortOrder, filteredData);
      if (newSortedData.length >= 1) {
        SetFilteredData(newSortedData);
      }
    }
    if (sortOrder === 'best_selling') {
      getCollectionFilterData('BEST_SELLING');
    }
  }, [sortOrder]);

  //component contents
  if (!isLoading && !isError) {
    if (productData && productData.length > 0) {
      // const pageScrollProductWise = localStorage.getItem('pageHistory');
      /*
      setTimeout(() => {
        const scrollClickElements = document.querySelector('.scrollClick');
        // console.log(scrollClickElements, 'link');
        if (scrollClickElements != null) {
          // scrollClickElements.click();
          localStorage.removeItem('pageHistory');

          // localStorage.removeItem('defaultHeight');

          localStorage.removeItem('pageCountHistory');
        }
      }, 500);
      */
      //these divs need to be simplified and reduced
      return (
        <div>
          {/* {pageScrollProductWise ? (
            <a href={'#' + pageScrollProductWise} class="scrollClick"></a>
          ) : null} */}
          <div style={{ display: 'grid' }}>
            <div className="leftsideFilters">Filter Products</div>
            <div className={blurEffect ? 'blureffect prodList' : 'prodList'}>
              <span className="menu-filter" onClick={handleClick}>
                <svg viewBox="0 0 100 80" width="20" height="30">
                  <rect width="100" height="10"></rect>
                  <rect y="30" width="100" height="10"></rect>
                  <rect y="60" width="100" height="10"></rect>
                </svg>
                <label>Filters</label>
              </span>
              <div className="filterSection" id="filterSection">
                <div className="filtersection-center" ref={ref}>
                  <em onClick={handleClick} className="filtersection-close">
                    <svg
                      viewPort="0 0 12 12"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <line
                        x1="1"
                        y1="11"
                        x2="11"
                        y2="1"
                        stroke="black"
                        stroke-width="2"
                      />
                      <line
                        x1="1"
                        y1="1"
                        x2="11"
                        y2="11"
                        stroke="black"
                        stroke-width="2"
                      />
                    </svg>
                  </em>
                  {filterData &&
                    filterData.map((filterType, index) => {
                      // console.log(filterType,'filterTypefilterTypefilterType',index)
                      return (
                        <CollectionFilter
                          key={filterType.attr}
                          index={index}
                          activeFilterIndex={activeFilterIndex}
                          filterType={filterType}
                          filterTypeProducts={filterTypeProducts}
                          appliedFilters={appliedFilters}
                          updateValueToFilters={updateValueToFilters}
                          isFilterCollapsed={isFilterCollapsed}
                          handleFilterCollapse={handleFilterCollapse}
                          SetapplyFilterCheck={SetapplyFilterCheck}
                          PriceFilter={PriceFilter}
                        />
                      );
                    })}
                </div>
                <div
                  className="filterSectionClosed"
                  onClick={handleClick}
                ></div>
              </div>
              <div className="collection-filters-applied">
                <AppliedFilters
                  appliedFilters={appliedFilters}
                  setAppliedFilters={SetAppliedFilters}
                  SetLastFilterSelect={SetLastFilterSelect}
                  shopifyObj={shopifyObj}
                />
              </div>
              <div className="row">
                <div className="col-6 filer-aap-left">
                  {filteredData.length == 1
                    ? filteredData.length + ' product'
                    : ''}
                  {filteredData.length > 1
                    ? filteredData.length + ' products'
                    : ''}
                </div>
                <div
                  className="col-6  filer-aap-right"
                  style={{
                    textAlign: 'right',
                  }}
                >
                  <ProductSort
                    appliedFilters={appliedFilters}
                    handleChangeSortOrder={handleChangeSortOrder}
                    currentSortOrder={sortOrder}
                    isCollection={true}
                  />
                </div>
              </div>
              <ProductList
                filteredData={filteredData}
                productsPerPage={productsPerPage}
                ShowOptions={ShowOptions}
                SetShowOptions={SetShowOptions}
                collectionProductPop={collectionProductPop}
                setCollectionProductPop={setCollectionProductPop}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return <p>Sorry, no products found in the collection</p>;
    }
  }
  if (isLoading && !isError) {
    return (
      <p>
        <Spinner />
      </p>
    );
  }
  if (isError) {
    if (productData) {
      return (
        <>
          <div className="prodList">
            <div className="collection-filters-applied">
              <AppliedFilters
                appliedFilters={appliedFilters}
                setAppliedFilters={SetAppliedFilters}
                SetLastFilterSelect={SetLastFilterSelect}
                shopifyObj={shopifyObj}
              />
            </div>
            <p>Something went wrong...!</p>
          </div>
        </>
      );
    }
  }
}
